import { createContext, useContext, useMemo, useEffect, useCallback } from "react";
import { useSessionStore } from "../stores/sessionStore";
import { useSettingStore } from "../stores/settingStore";
import { api } from "../config/middleware";
import { API_GETSETTING } from "../config/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const { profile, loggedIn, appToken, loginSuccess, logout } = useSessionStore();

  const setBillMode = useSettingStore((s) => s.setBillMode);
  const resetAllSetting = useSettingStore((s) => s.resetAll);

  // โหลด setting ตอนมี brId (หลัง loginSuccess)
  useEffect(() => {
    const brId = profile?.brId;
    if (brId === undefined || brId === null) return;

    (async () => {
      try {
        const res = await api.get(API_GETSETTING, { params: { BRID: brId } });
        if (res.data?.statustext !== "SUCCESS") return;

        const s = res.data?.data || {};
        setBillMode(brId, s.billMode ?? 0); // sync เข้า zustand ให้ useRoutes ใช้ได้ทันที
      } catch (e) {
        console.error("fetch setting error:", e);
      }
    })();
  }, [profile?.brId, setBillMode]);

  // logout แล้วเคลียร์ setting ที่ persist ค้าง
  const logoutAndClear = useCallback(() => {
    resetAllSetting();
    logout();
  }, [resetAllSetting, logout]);

  const value = useMemo(
    () => ({
      user: profile,
      role: (profile?.role || "user").toLowerCase(),
      isAuthenticated: loggedIn,
      token: appToken,

      login: (tk, role, fullUserObj) => {
        const safe = {
          role: (role || fullUserObj?.role || "user").toLowerCase(),
          psId: fullUserObj?.psId ?? null,
          username: fullUserObj?.empUsername ?? fullUserObj?.username ?? null,
          orgId: fullUserObj?.orgId ?? null,
          tnId: fullUserObj?.tnId ?? null,
          brId: fullUserObj?.brId ?? null,
          avatar: fullUserObj?.avatar ?? null,
        };
        loginSuccess(safe, tk || null);
      },

      logout: logoutAndClear, 
    }),
    [profile, loggedIn, appToken, loginSuccess, logoutAndClear]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
